import { PayloadAction } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { IChatpracticeEvaluation } from "../../../Components/ChatbotPracticeEvaluation/IChatpracticeEvaluation";
import {
  failureChatpracticeEvaluation,
  successChatpracticeEvaluation,
} from "./ChatpracticeEvaluationSlicer";

const ChatpracticeEvaluationApi = (
  action: PayloadAction<IChatpracticeEvaluation>
) => {
  return api.post("/api/exam/ai-chat", action.payload);
};

export function* ChatpracticeEvaluationCall(
  action: PayloadAction<IChatpracticeEvaluation>
) {
  try {
    const respons: AxiosResponse = yield call(
      ChatpracticeEvaluationApi,
      action
    );
    yield put(successChatpracticeEvaluation(respons.data));
  } catch (error) {
    yield put(failureChatpracticeEvaluation(error));
  }
}
